// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0fa4144c","455":"1163b81e"}[chunkId] + ".chunk.js";
};